import React from "react";
import { useGameState } from "context/GameContext";
import Flash from "react-reveal/Flash";
// Css
import classes from "./ElectionTracker.module.scss";

const ElectionTracker: React.FC = () => {
  const { electionDeclined } = useGameState();

  return (
    <div className={classes.container}>
      <img
        className={classes.image}
        src="assets/img/board/election-tracker.svg"
        alt=""
      />
      {[...Array(electionDeclined + 1)].map((item, index) => (
        <Flash key={index}>
          {index < electionDeclined + 1 && <div className={classes.circle} />}
        </Flash>
      ))}
    </div>
  );
};

export default ElectionTracker;
